import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { subscribe_path } from '@routes';

import { ProButton } from '../../Button/variants';
import LogoTIProWithIconTI from '../../Images/Rebranding/LogoTIProWithIconTI';

export const HERO_PHONE_GIF_URL = 'https://tii.imgix.net/global/pro/HeroPhone.gif';
export const TEXTURE_IMAGE_URL = 'https://tii.imgix.net/global/pro/Texture.png';

interface ProHeroProps {
  defaultProOfferCode: string;
}

const ProHero = ({ defaultProOfferCode }: ProHeroProps) => {
  return (
    <div className="flex items-center border-0 border-b border-solid border-grayscale-beige pb-48 lg:pb-64">
      <div className="relative hidden h-[536px] w-[350px] flex-shrink-0 bg-[url('https://tii.imgix.net/global/pro/Texture.png')] bg-contain md:block lg:h-[623px] lg:w-[408px]">
        <LazyImgixImage
          alt="Pro image"
          className="!flex w-full"
          src={HERO_PHONE_GIF_URL}
          wrapperClassName="absolute left-72 top-28 block w-[250px] rounded-36 shadow-pro lg:left-[87px] lg:top-32 lg:w-[290px]"
        />
      </div>
      <div className="md:ml-16">
        <LogoTIProWithIconTI className="mb-32 sm:mb-48 lg:mb-64" />
        <h3 className="m-0 mb-8 font-suisse-works text-headline-sm text-primary-black sm:text-headline-md">
          Always be the most informed person in the room.
        </h3>
        <p className="m-0 mb-32 font-suisse-neue text-subheadline-sm text-primary-black lg:text-subheadline-md">
          The Information Pro is a subscription that provides access to The Information’s
          proprietary data tools on top of exclusive journalism. We built these tools for our
          newsroom because they didn’t exist anywhere else—and now we’re sharing them with our
          subscribers.
        </p>
        <ProButton as="link" href={subscribe_path({ plan: defaultProOfferCode })}>
          Subscribe today
        </ProButton>
      </div>
    </div>
  );
};
export default ProHero;
